// extracted by mini-css-extract-plugin
export default {"mainTr":"TableRowTopicCaseWithCollapse_mainTr__JzHDL","hoverTr":"TableRowTopicCaseWithCollapse_hoverTr__54ewH","collapseTr":"TableRowTopicCaseWithCollapse_collapseTr__+kTjB"};